import type { ISearchSuggestionsResponse } from "~/typings/api/searchSuggestions";

export default () => {
  const requestSearchSuggestions = async (searchValue: string) => {
    const { $transport } = useNuxtApp();
    const storesStore = useStoresStore();

    return $transport<ISearchSuggestionsResponse>(urls.searchSuggestions.get, {
      query: {
        term: searchValue,
        storetype: String(storesStore.requestShopType),
        catalogtype: String(API_CATALOG_TYPE),
      },
    });
  };

  const requestPopularSearchSuggestions = async () => {
    const { $transport } = useNuxtApp();
    const storesStore = useStoresStore();

    return $transport<ISearchSuggestionsResponse>(urls.searchSuggestions.popular, {
      query: {
        storetype: String(storesStore.requestShopType),
        catalogtype: String(API_CATALOG_TYPE),
      },
    });
  };

  return {
    requestSearchSuggestions,
    requestPopularSearchSuggestions,
  };
};
